export default {
	long: {
		en: 'English',
		uk: 'Ukrainian',
		// he: 'Hebrew',
		// pl: 'Polish',
		// lv: 'Latvian',
		// lt: 'Lithuanian',
		// ru: 'Russian'
	},
	short: {
		en: 'Eng',
		uk: 'Ukr',
		// he: 'He',
		// pl: 'Pol',
		// lv: 'Lv',
		// lt: 'Lt',
		// ru: 'Rus'
	},
	/**
	 * remove
	 */
	en: 'English',
	uk: 'Ukrainian',
	// he: 'Hebrew',
	// pl: 'Polish',
	// lv: 'Latvian',
	// lt: 'Lithuanian',
	// ru: 'Russian'
}
